module.exports = __webpack_public_path__ + "static/media/download.21f12885.svg";